import i18n from '../i18n';
import type { Patient } from '../api/types';
import { age } from './dates';

export const patientName = (p: Pick<Patient, 'last_name' | 'first_name'>): string =>
  `${p.last_name} ${p.first_name}`;

/** «Ж, 32 года» */
export function sexAge(p: Pick<Patient, 'sex' | 'birth_date'>): string {
  const a = age(p.birth_date);
  return i18n.t('patient.sexAge', { sex: i18n.t(`patient.sexShort.${p.sex}`), age: a ?? '—' });
}
